export default __webpack_public_path__ + "static/media/dash4.ab395d08.svg";